import { apiSlice } from "../../api/apiSlice";

export const findADealApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEmailConfig: builder.query({
      query: () => "/api/v1/admin/find-a-deal/email-config",
    }),
    updateEmailConfig: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/find-a-deal/email-config",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const { useGetEmailConfigQuery, useUpdateEmailConfigMutation } =
  findADealApiSlice;








